// Moved jQuery call to document ready to ensure jQuery is loaded
import Parts from '../images.73/devices/parts/GLOBAL_PARTS.js'
import IconsSelector from './reuse/icons_selector.js';
IconsSelector.register();
globalThis.SIZE = new Size();
import Render from './renderers/render.js'
// import IconsSelector from './reuse/icons_selector.js';
import StickerSettings from './reuse/sticker_settings.js'

// Define global functions first (before class instantiation)
globalThis.ERROR = (text) => {
    console.error(text);
    $('.alert').removeClass('d-none').addClass('show');
    $('.alertText').html(text);
    setTimeout(() => { $('.alert').addClass('d-none').removeClass('show') }, 3000)
}

globalThis.ID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

// Initialize global objects - moved to document ready to ensure dependencies are loaded
function initializeGlobalObjects() {
    // Starting global object creation

    try {
        // Generate unique ID function first
        globalThis.ID = () => {
            return Math.random().toString(36).substr(2, 9);
        };
        // ID function created

        globalThis.RENDER = new Render();
        // RENDER created

        globalThis.STORAGE = new Storage();
        // STORAGE created

        globalThis.RAILS = new Rails();
        // RAILS created

        globalThis.MODAL_MODULE = new ModalModule();
        // MODAL_MODULE created

        globalThis.MODAL_RAIL_SETTINGS = new ModalRailSettings();
        // MODAL_RAIL_SETTINGS created

        globalThis.MODAL_STICKER_SETTINGS = new ModalStickerSettings();
        // MODAL_STICKER_SETTINGS created

        globalThis.MODAL_BUS = new ModalBus();
        // MODAL_BUS created

        globalThis.MODAL_CONNECTOR = new ModalConnector();
        // MODAL_CONNECTOR created

        globalThis.MODAL_INPUT = new ModalInput();
        // MODAL_INPUT created

        globalThis.PRINT = new Print();
        // PRINT created

        globalThis.SPECS = new Specs();
        // SPECS created

        globalThis.SCHEMA = new Schema(Rails);
        // SCHEMA created

        globalThis.FILES = new ControlsMenu();
        // FILES created

        globalThis.PARTS = Parts;
        // PARTS assigned

        globalThis.MENU = new Menu();
        // MENU created

        globalThis.REUSE = {}
        REUSE.StickerSettings = StickerSettings;
        REUSE.IconsSelector = IconsSelector;
        // REUSE object configured

        // All global objects created successfully
    } catch (error) {
        console.error('initializeGlobalObjects: Error creating global objects:', error);
        throw error;
    }
}

// Wait for jQuery, Bootstrap Slider and Bootstrap to be available, then initialize
function waitForLibraries() {
    if ((typeof $ !== 'undefined' || typeof jQuery !== 'undefined') && window.SLIDER_READY && window.BOOTSTRAP_READY) {
        // Ensure $ is available
        if (typeof $ === 'undefined' && typeof jQuery !== 'undefined') {
            window.$ = jQuery;
        }

        // All libraries ready, starting app initialization
        $(document).ready(function () {
            // Detect Electron (desktop) environment early
            const IS_DESKTOP_ENV = (typeof process !== 'undefined' && process.versions && !!process.versions.electron);
            if (IS_DESKTOP_ENV) {
                // Persist flag so other scripts can see it even if main process injects later
                window.IS_DESKTOP = true;
            }

            // Initialize all global objects first
            // Initializing global objects
            initializeGlobalObjects();

            // Show box page by default (moved from top of file)
            // Showing box page
            $(`*[data-page=box]`).show(); // todo check if we need this

            // Starting RAILS.render()
            RAILS.render();

            // Electron export handlers (initial step: labels PDF/PNG)
            try {
                if (window.IS_DESKTOP && typeof require === 'function') {
                    const { ipcRenderer } = require('electron');
                    ipcRenderer.on('export-request', (_event, payload) => {
                        if (!payload || !payload.category || !payload.format) return;
                        if (payload.category === 'labels') {
                            // Ensure print tab is initialized before exporting
                            const ensurePrintTab = () => {
                                if (typeof globalThis.PRINT === 'undefined') return false;
                                // If print page container missing orientation links, render
                                if (!document.querySelector('#printBox')) {
                                    return false; // unexpected structure
                                }
                                // If orientation selector absent, trigger full print render
                                if (!document.querySelector('a.paperOrientationLink')) {
                                    // Activate print tab (re-using existing navigation logic)
                                    if (typeof $ !== 'undefined') {
                                        const printNav = document.querySelector('*[data-mode=print]');
                                        if (printNav) {
                                            // simulate click without scrolling issues
                                            $('*[data-page]').hide();
                                            $(`*[data-page=print]`).show();
                                            $(`*[data-mode]`).addClass('muted').removeClass('selected');
                                            $(`*[data-mode="print"]`).removeClass('muted').addClass('selected');
                                            globalThis.ACTIVE_TAB = 'print';
                                            PRINT.render();
                                            PRINT.renderStickers();
                                        }
                                    }
                                }
                                return true;
                            };
                            ensurePrintTab();
                            switch (payload.format) {
                                case 'pdf':
                                    if (globalThis.PRINT && typeof globalThis.PRINT.download === 'function') {
                                        globalThis.PRINT.download('pdf');
                                    }
                                    break;
                                case 'png':
                                    if (globalThis.PRINT && typeof globalThis.PRINT.download === 'function') {
                                        globalThis.PRINT.download('png');
                                    }
                                    break;
                                case 'dxf':
                                    if (globalThis.PRINT) {
                                        // Ensure print UI rendered so modal exists
                                        if (typeof globalThis.PRINT.render === 'function') {
                                            PRINT.render();
                                            PRINT.renderStickers();
                                        }
                                        const modalEl = document.getElementById('downloadDxfModal');
                                        if (!modalEl && typeof globalThis.PRINT.renderDxfModal === 'function') {
                                            // Force re-render of print section to inject modal if missing
                                            try { PRINT.render(); } catch (e) { }
                                        }
                                        // Use Bootstrap modal if available
                                        if (typeof $ !== 'undefined' && $('#downloadDxfModal').modal) {
                                            $('#downloadDxfModal').modal('show');
                                        } else {
                                            // Fallback: direct export (rows mode) if modal not available
                                            if (typeof globalThis.PRINT.download === 'function') {
                                                globalThis.PRINT.download('dxf');
                                            }
                                        }
                                    }
                                    break;
                                default:
                                    console.warn('Unsupported labels export format (not yet implemented):', payload.format);
                            }
                        }
                        else if (payload.category === 'schema') {
                            // Ensure schema tab is active & rendered before export to avoid blank capture
                            if (typeof globalThis.SCHEMA === 'undefined') return;

                            const runSchemaExport = () => {
                                switch (payload.format) {
                                    case 'pdf':
                                        if (SCHEMA && typeof SCHEMA.downloadPdf === 'function') {
                                            SCHEMA.downloadPdf();
                                        }
                                        break;
                                    case 'png':
                                        if (SCHEMA && typeof SCHEMA.downloadPng === 'function') {
                                            SCHEMA.downloadPng();
                                        }
                                        break;
                                    default:
                                        console.warn('Unsupported schema export format:', payload.format);
                                }
                            };

                            // If already on schema tab and page element exists & visible, export immediately
                            const schemaNode = document.querySelector('.schemaPaper');
                            if (globalThis.ACTIVE_TAB === 'schema' && schemaNode && schemaNode.offsetParent !== null && schemaNode.clientWidth > 0) {
                                runSchemaExport();
                            } else {
                                // Activate schema tab (mimic navigation) and wait for render
                                if (typeof $ !== 'undefined') {
                                    $('*[data-page]').hide();
                                    $(`*[data-page=schema]`).show();
                                    $(`*[data-mode]`).addClass('muted').removeClass('selected');
                                    $(`*[data-mode="schema"]`).removeClass('muted').addClass('selected');
                                    globalThis.ACTIVE_TAB = 'schema';
                                }
                                // Trigger render (idempotent)
                                try { SCHEMA.render(); } catch (e) { console.warn('SCHEMA.render() failed before export', e); }

                                let attempts = 0;
                                const MAX_ATTEMPTS = 60; // ~3s at 50ms
                                const waitReady = () => {
                                    const node = document.querySelector('.schemaPaper');
                                    if (node && node.clientWidth > 0 && node.clientHeight > 0) {
                                        runSchemaExport();
                                    } else if (attempts++ < MAX_ATTEMPTS) {
                                        setTimeout(waitReady, 50);
                                    } else {
                                        console.warn('Schema export: proceeding despite schema not fully rendering');
                                        runSchemaExport();
                                    }
                                };
                                // Small delay to allow layout & render scheduling
                                setTimeout(waitReady, 30);
                            }
                        }
                        else if (payload.category === 'spec') {
                            const ensureSpecsTab = () => {
                                if (typeof globalThis.SPECS === 'undefined') return false;
                                if (!document.querySelector('table.specs')) {
                                    if (typeof $ !== 'undefined') {
                                        $('*[data-page]').hide();
                                        $(`*[data-page=specs]`).show();
                                        $(`*[data-mode]`).addClass('muted').removeClass('selected');
                                        $(`*[data-mode="specs"]`).removeClass('muted').addClass('selected');
                                        globalThis.ACTIVE_TAB = 'specs';
                                        SPECS.render();
                                        SPECS.renderSpecs();
                                    }
                                }
                                return true;
                            };
                            ensureSpecsTab();
                            if (payload.format === 'excel') {
                                if (SPECS && typeof SPECS.generateExcel === 'function') {
                                    SPECS.generateExcel();
                                }
                            } else {
                                console.warn('Unsupported specs export format:', payload.format);
                            }
                        }
                    });
                }
            } catch (e) {
                console.warn('IPC export handlers initialization failed (non-electron env?):', e);
            }

            initPageNavigation();
            bindAlerts();

            if (!globalThis.SETTINGS) {
                globalThis.SETTINGS = new Settings();
            }

            // Helper to strip/hide auth & cloud-only UI for desktop app
            function disableAuthUIForDesktop() {
                // Hide / remove auth-related elements
                const selectorsToRemove = [
                    '.auth-required',
                    '.unauth-required',
                    '#firebaseAuthModal',
                    '#authModal',
                    '.firebase-user-menu',
                    '.youtube',
                    '.telegram',
                    '.download'
                ];
                selectorsToRemove.forEach(sel => {
                    document.querySelectorAll(sel).forEach(el => el.remove());
                });

                // Remove projects tab entirely for desktop version
                const projectsTab = document.querySelector('[data-mode="projects"]');
                if (projectsTab) {
                    projectsTab.remove();
                }

                // Remove menu dropdown entries that reference FIREBASE_MANAGER.* in inline handlers
                document.querySelectorAll('[onclick*="FIREBASE_MANAGER"]').forEach(el => {
                    // If it's a list item / link inside dropdown -> hide gracefully
                    el.style.display = 'none';
                });

                // Provide minimalist replacements so other code calling these methods doesn't fail
                if (!globalThis.FIREBASE_MANAGER) {
                    globalThis.FIREBASE_MANAGER = {
                        currentUser: null,
                        showAuth: () => { },
                        loadFromCloud: () => globalThis.ERROR && ERROR(I18N.t('status.cloudUnavailableDesktop')),
                        shareCurrentProject: () => globalThis.ERROR && ERROR(I18N.t('status.cloudUnavailableDesktop')),
                        loadPublicProjectsList: () => { },
                        loadProjectsList: () => { },
                        triggerAutoSave: () => { },
                        generateUniqueProjectName: async () => (STORAGE?.get('settings')?.boxName || I18N.t('common.newProject')),
                        logout: () => { },
                        signInWithGoogle: () => { },
                        loadProjectFromUrl: () => null
                    };
                }
            }

            // Initialize Firebase Manager lazily (web only). Desktop gets a stub + auth UI removed.
            if (IS_DESKTOP_ENV) {
                disableAuthUIForDesktop();
            } else {
                installFirebaseStub();
                scheduleFirebaseLoad();
            }

            // ---- Lazy Firebase helpers (web) ----
            // Firestore/Auth SDK + firebase-manager.js are no longer loaded eagerly.
            // ensureFirebaseManager() loads them once and constructs the real manager.

            async function ensureFirebaseManager() {
                const current = globalThis.FIREBASE_MANAGER;
                if (current && current.constructor && current.constructor.name === 'FirebaseManager') {
                    return current;
                }
                if (globalThis.FIREBASE_MANAGER_PROMISE) {
                    return globalThis.FIREBASE_MANAGER_PROMISE;
                }
                const promise = new Promise((resolve, reject) => {
                    if (typeof FirebaseManager !== 'undefined') {
                        globalThis.FIREBASE_MANAGER = new FirebaseManager();
                        resolve(globalThis.FIREBASE_MANAGER);
                        return;
                    }
                    if (globalThis.ResourceLoader) {
                        ResourceLoader.ensureFirebase(() => {
                            try {
                                if (typeof FirebaseManager === 'undefined') {
                                    return reject(new Error('FirebaseManager not loaded'));
                                }
                                globalThis.FIREBASE_MANAGER = new FirebaseManager();
                                resolve(globalThis.FIREBASE_MANAGER);
                            } catch (e) {
                                reject(e);
                            }
                        });
                    } else {
                        reject(new Error('ResourceLoader missing'));
                    }
                });
                globalThis.FIREBASE_MANAGER_PROMISE = promise;
                promise.finally(() => { globalThis.FIREBASE_MANAGER_PROMISE = null; }).catch(() => { });
                return promise;
            }

            function installFirebaseStub() {
                if (globalThis.FIREBASE_MANAGER) return;
                const replay = (method, args) => {
                    ensureFirebaseManager().then(m => {
                        if (m && typeof m[method] === 'function') m[method](...args);
                    }).catch(() => { });
                };
                globalThis.FIREBASE_MANAGER = {
                    currentUser: null,
                    showAuth: (...a) => replay('showAuth', a),
                    loadFromCloud: (...a) => replay('loadFromCloud', a),
                    shareCurrentProject: (...a) => replay('shareCurrentProject', a),
                    loadPublicProjectsList: (...a) => replay('loadPublicProjectsList', a),
                    loadProjectsList: (...a) => replay('loadProjectsList', a),
                    triggerAutoSave: (...a) => replay('triggerAutoSave', a),
                    logout: (...a) => replay('logout', a),
                    signInWithGoogle: (...a) => replay('signInWithGoogle', a),
                    generateUniqueProjectName: async () => (STORAGE?.get('settings')?.boxName || I18N.t('common.newProject')),
                    loadProjectFromUrl: () => null
                };
            }

            function scheduleFirebaseLoad() {
                const doLoad = () => { ensureFirebaseManager().catch(() => { }); };
                if (typeof requestIdleCallback === 'function') {
                    requestIdleCallback(doLoad, { timeout: 4000 });
                } else {
                    setTimeout(doLoad, 2500);
                }
            }

            // Full initialization complete
        });
    } else {
        // Libraries not ready yet, wait a bit more
        if (typeof $ === 'undefined' && typeof jQuery === 'undefined') {
            // Waiting for jQuery
        } else if (!window.SLIDER_READY) {
            // Waiting for Bootstrap Slider
        }
        setTimeout(waitForLibraries, 100);
    }
}

// Start the initialization process
waitForLibraries();

// ---- Global export progress overlay helpers ----
globalThis.EXPORT_PROGRESS = {
    counter: 0,
    el: null,
    ensure() {
        if (!this.el) {
            this.el = document.getElementById('exportProgress');
        }
        return this.el;
    },
    show(text = I18N.t('common.generating')) {
        const el = this.ensure();
        if (!el) return;
        this.counter++;
        el.classList.remove('error', 'success', 'd-none');
        el.querySelector('.exportProgressText')?.replaceChildren(document.createTextNode(text));
        el.classList.add('showing');
    },
    done(success = true, message) {
        const el = this.ensure();
        if (!el) return;
        if (this.counter > 0) this.counter--;
        if (this.counter === 0) {
            if (message) {
                el.querySelector('.exportProgressText')?.replaceChildren(document.createTextNode(message));
            }
            el.classList.remove('showing');
            el.classList.add(success ? 'success' : 'error');
            setTimeout(() => {
                // hide only if no new tasks appeared meanwhile
                if (this.counter === 0) {
                    el.classList.add('d-none');
                    el.classList.remove('success', 'error');
                }
            }, success ? 900 : 1600);
        }
    },
    // Универсальный guard: принимает промис или функцию, показывая индикатор и закрывая его по завершению
    wrap(label, work, { successText = I18N.t('export.done'), errorText = I18N.t('export.error') } = {}) {
        try { this.show(label); } catch (_) { }
        let p;
        try {
            p = (typeof work === 'function') ? work() : work;
        } catch (e) {
            this.done(false, errorText);
            return Promise.reject(e);
        }
        if (!p || typeof p.then !== 'function') {
            this.done(true, successText);
            return Promise.resolve(p);
        }
        return p.then(res => { this.done(true, successText); return res; })
            .catch(err => { this.done(false, errorText); throw err; });
    }
};

const initPageNavigation = () => {
    $('*[data-mode]').on('click', (e) => {
        e.preventDefault();

        const mode = $(e.currentTarget).data('mode');
        if (!globalThis.ACTIVE_TAB) {
            globalThis.ACTIVE_TAB = mode;
        }
        else {
            if (globalThis.ACTIVE_TAB == mode) {
                // Already on tab, no need to switch
                return;
            }
            globalThis.PREVIOUS_TAB = globalThis.ACTIVE_TAB;
        }
        globalThis.ACTIVE_TAB = mode


        $('*[data-page]').hide();
        $(`*[data-page=${mode}]`).show();
        $(`*[data-mode]`).addClass('muted').removeClass('selected');
        $(`*[data-mode="${mode}"]`).removeClass('muted').addClass('selected');



        switch (mode) {
            case 'box': {
                // RAILS.renderBox();
                // RAILS.renderBuses();
                // RAILS.renderDevices();
                // RAILS.renderSlider();

                RAILS.render();
                FILES.renderSettingsMenu();
                break;
            }
            case 'print': {
                PRINT.render();
                PRINT.renderStickers();

                if (!globalThis.MAKERJS_LOADED) {
                    globalThis.MAKERJS_LOADED = true;
                    if (globalThis.ResourceLoader) {
                        ResourceLoader.ensureMaker();
                    } else {
                        var script = document.createElement('script');
                        script.src = 'js.73/src/makerjs/browser.maker.js';
                        document.getElementsByTagName('body')[0].appendChild(script);
                    }
                }

                break;
            }

            case 'specs': {
                SPECS.render();
                SPECS.renderSpecs();
                break;
            }

            case 'schema': {
                SCHEMA.render();
                break;
            }

            case 'settings': {
                // settings initiation moved to the top, because we need it on the menu on main page
                globalThis.SETTINGS.render();
                break;
            }

            case 'projects': {
                // Handle projects tab
                if (!globalThis.FIREBASE_MANAGER) {
                    console.error('Firebase manager not initialized');
                    return;
                }

                if (!globalThis.FIREBASE_MANAGER.currentUser) {
                    // User not logged in, show only public projects
                    globalThis.FIREBASE_MANAGER.loadProjectsList();
                } else {
                    // User is logged in, load all projects (user + public)
                    globalThis.FIREBASE_MANAGER.loadProjectsList();
                }
                break;
            }
        }

    })
}

// Static data-i18n attributes are updated by i18n.js. The active section also
// needs a lightweight rerender because its templates call I18N.t() at runtime.
globalThis.I18N_ON_LANG_CHANGED = () => {
    switch (globalThis.ACTIVE_TAB) {
        case 'box':
            globalThis.RAILS?.render();
            globalThis.FILES?.renderSettingsMenu();
            break;
        case 'print':
            globalThis.PRINT?.render();
            globalThis.PRINT?.renderStickers();
            break;
        case 'specs':
            globalThis.SPECS?.render();
            globalThis.SPECS?.renderSpecs();
            break;
        case 'schema':
            globalThis.SCHEMA?.render();
            break;
        case 'settings':
            globalThis.SETTINGS?.renderStickerSettings();
            break;
        case 'projects':
            globalThis.FIREBASE_MANAGER?.loadProjectsList();
            break;
    }
};

const bindAlerts = () => {
    $('.alert>.btn-close').on('click', () => {
        $('.alert').addClass('d-none').removeClass('show');
        $('.alertText').html("");
    })

}
// const copyright = () => {
//     $('.year').html(new Date().getFullYear());
// }

// Video modal functionality moved to waitForJQuery function

/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 168) {
        document.getElementById("pageControls").style.top = "0";
        document.getElementById("pageControls").style.position = "fixed";
        // document.getElementById("pageControls").style.backgroundColor = "red";
        document.getElementById("pageControlsContent").style.boxShadow = "rgb(0, 0, 0, 0.3) 0px 5px 5px"
    } else {
        document.getElementById("pageControls").style.top = "";
        document.getElementById("pageControls").style.position = "static";
        document.getElementById("pageControls").style.backgroundColor = "";
        document.getElementById("pageControlsContent").style.boxShadow = ""
    }
    prevScrollpos = currentScrollPos;
}



globalThis.SCRIPT = (url) => {
    // Fix absolute paths for Electron - remove leading slash to make them relative
    if (url.startsWith('/')) {
        url = url.substring(1);
    }

    // Loading script

    return new Promise((resolve, reject) => {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = url;

        // Add error handling
        s.onerror = function () {
            console.error('SCRIPT: Failed to load script:', url);
            reject(new Error(`Failed to load script: ${url}`));
        };

        s.onload = function () {
            // Script loaded successfully
            resolve();
        };

        var x = document.getElementsByTagName('body')[0];
        x.appendChild(s);
    });
}

// Helper function to wait for a global variable to be available
globalThis.WAIT_FOR_GLOBAL = (globalName, timeout = 5000) => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        const checkGlobal = () => {
            if (typeof window[globalName] !== 'undefined') {
                // Global variable is now available
                resolve(window[globalName]);
                return;
            }

            if (Date.now() - startTime > timeout) {
                console.error(`WAIT_FOR_GLOBAL: ${globalName} not available after ${timeout}ms`);
                reject(new Error(`Timeout waiting for ${globalName}`));
                return;
            }

            setTimeout(checkGlobal, 50);
        };

        checkGlobal();
    });
}

